var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookieGray = function SvgCookieGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6E6E6E",
    fillRule: "evenodd",
    d: "M9.54 1.66c.041.72.39 1.45 1.02 1.978.409.343.88.555 1.356.638.585.102 1.178.01 1.672-.271a2.12 2.12 0 0 0-.131 1.667c.12.352.334.677.64.934a2.1 2.1 0 0 0 1.943.407 8 8 0 0 1 .042 1.528 8 8 0 1 1-6.15-8.33c-.293.43-.42.937-.391 1.449m.056 3.127c.68.571 1.501.915 2.339 1.006.167.74.569 1.434 1.197 1.962.436.366.933.61 1.45.737A6.5 6.5 0 1 1 8.034 1.5c-.002 1.232.573 2.457 1.562 3.287M7.6 4.5H6.1V6h1.5zm2.5 5.5h1v1h-1zM5.6 8.5H4.1V10h1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgCookieGray;